<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" @submit.prevent.native="startSearch">        
				<el-form-item>
					<el-input v-model="searchFilter" placeholder="Search"  @change='startSearch'></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon='el-icon-search' size='small' v-on:click="startSearch">{{lang.butSearch}}</el-button>
					<el-button type="" size='small' v-on:click="searchFilter='';getRecords();">C</el-button>
				</el-form-item>
        
				<span style='float:right' v-if="this.userdept.includes('WRD')">
  				<el-form-item>
	  				<el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">{{lang.butAdd}}</el-button>
		  		</el-form-item>
				</span>
			</el-form>
		</el-col>

		<!--Lijst-->
		<el-table :data="content" stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
 			
      <el-table-column prop="department" label="Owner" min-width="50" sortable>
			</el-table-column>
      <el-table-column prop="group" label="Group" min-width="129" sortable>
			</el-table-column>
      <el-table-column prop="code" label="Code" min-width="129" sortable>
			</el-table-column>
      <el-table-column prop="title" label="Title" min-width="200" sortable>
			</el-table-column>

			<el-table-column label="" width="100" fixed='right'>

				<template slot-scope="scope">
					<el-button type='success' size="small" icon="el-icon-edit"  @click="handleEdit(scope.row)"></el-button>
          <el-button :disabled="!userdept.includes('WRD')" type="danger" size="small" icon="el-icon-delete"  @click="handleDel(scope.row)"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- Toolbar -->
		
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev,pager,next,jumper,sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :current-page='currentPage' :page-sizes="[10, 15, 25, 50, 100, 1000]" @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='font-size:80%;margin:9px;float:right'>{{mainTotal}} records found</span>
			</el-col>
    
		<!--Wijzig record -->
		<el-dialog :title="editTitle" :visible.sync="editFormVisible"
                   :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
        <el-tabs type="card">
          <!-- -------------------------------------------------------------------------------------- -->
				  <el-tab-pane>
            <span slot='label'><i class='el-icon-date'></i> News</span>
    		
            <el-form-item label="Group :" prop="group">
    					<el-input :disabled="this.editMode=='save'" v-model="editForm['group']" auto-complete="off"></el-input>
		    		</el-form-item>
            <el-form-item label="Code :" prop="code">
    					<el-input :disabled="this.editMode=='save'" v-model="editForm['code']" auto-complete="off"></el-input>
		    		</el-form-item>
    			  
            <el-form-item label="Owner :" prop="department">    		
              <el-select :disabled="this.editMode=='save'" v-model="editForm['department']" placeholder="Department to Used" style='width:100%'>
                <el-option v-for="item in codes.depts" :key="item.value" :label="item.code + ' - ' + item.value"  :value="item.code"></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="Title :" prop="title">
    					<el-input v-model="editForm['title']" auto-complete="off"></el-input>
		    		</el-form-item>
            <el-form-item label="Text :" prop="text">
            	<wysiwyg style='height:300px !important' v-model="editForm['text']" />
		    		</el-form-item>
            <el-form-item label="Info Link :" prop="text">
    					<el-input v-model="editForm['link']" auto-complete="off"></el-input>
		    		</el-form-item>
  				</el-tab-pane>
				</el-tabs> 
			</el-form>

			<div slot="footer" class="dialog-footer">		  
				<el-button size='small' icon="el-icon-upload2"  @click.native="editFormVisible = false">{{lang.butCancel}}</el-button>
				<el-button size='small' type="primary" icon="el-icon-edit"  @click.native="editSubmit" :loading="editLoading">{{lang.butSave}}</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/system/xdata';

	export default {
		data() {
			return {
        QID         : util.Initialize(this.$router,"XD"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,

				editTitle   : "",
				editMode    : "",
				APICode     : "XData",
				mainFunc    : "Snippet",
				mainSubject : "Snippet",
        mainKey     : "code",
				mainKeyDesc : "title",
        searchFilter: '',		
        userdept: "",
        content: [],
				counter: {},
				related: [],
				currentPage: 1,
				mainTotal: 0,
		
				listLoading: false,
				editFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				editLoading: false,
				editForm: {},			
				editFormRules: {
					xdatacode: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		
		methods: {
		
      startSearch: function() {
        this.currentPage = 1;
        this.content = [];        
        this.getRecords();
      },
    // paginering wissel, reload page			
      selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

			// Ophalen record(s) via API
			getRecords() {
        
        let parg = {};
        parg.Params = {};
        parg.Params.search = this.searchFilter;  /* of search */
		
				this.listLoading = true;
				
        api.getListPage(parg).then((res) => {						
				  
          util.processMainResults(res);
          this.codes = util.codes;     
          this.mainTotal = util.payload[this.APICode].length;         
          this.userdept  = util.header["udepts"];
          if (this.mainTotal > 0)
          {
            if (this.serverPaging)
           	  this.content = util.getMainPayload(this.APICode);
			  		else {
 				  		this.contentSaved = util.getMainPayload(this.APICode);
  				    if (this.contentSaved.length > 0)
    				    this.selectPage(1);
  					}
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;

				})
        .catch((error) => {
          util.serverError(this);
        });
			},
			

			openRelated: function(row) {       
			},

			// Verwijder
			handleDel: function (row) {
				this.$confirm(text.getText("sdelM",this.mainSubject,row[this.mainKeyDesc]), 'Confirm', {
					type: 'warning',title: text.getText("sdelT",this.mainSubject)
				}).then(() => {
					this.listLoading = true;

          let parg = {};
          parg.Params = {};
          parg.Record = Object.assign({}, row);

				  api.removeRecord(parg).then((res) => {
		        util.processMainResults(res);
    				this.listLoading = false;
  					this.$notify({
	  				  title: text.data.conf,type: 'success',
		  				message: text.getText("delOK",this.mainSubject,row[this.mainKeyDesc])			  			 
				  	});
						this.getRecords();
					});

				}).catch(() => {

				});
			},
			
			// Display bewerkingsinterface
			handleEdit: function (row) {
        this.editMode = "save";
				this.editTitle = text.getText("modM",this.mainSubject,row[this.mainKeyDesc]);
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
			},
			
			
			// Toon nieuwe interface
			handleAdd: function () {
				this.editMode = "add";
				this.editTitle = text.getText("addM",this.mainSubject);
				this.editFormVisible = true;
				this.editForm = {};
			},

			// uitgeven
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
					  this.editLoading = true;
						
            let parg = {};
            parg.Params = {};
            parg.Record = Object.assign({}, this.editForm);

            if (this.editMode == "add") 
            {
							api.addRecord(parg).then((res) => {
                util.processMainResults(res);
                if (util.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("addOK",this.mainSubject,this.editForm.xdatacode)});
                else this.$notify({title: "Error",type: 'error',message: util.header.message});
		    				//this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
   			 	  		this.getRecords();
	  					});
            }
						else {
							api.saveRecord(parg).then((res) => {		  					
                util.processMainResults(res);
                if (util.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("modOK",this.mainSubject,this.editForm.xdatacode)});
                else this.$notify({title: "Error",type: 'error',message: util.header.message});
						    //this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
		    				this.getRecords();
	  					});
            }
					}
				});
			},

		},

		mounted() {
      window.onresize = this.reportWindowSize;
      this.reportWindowSize;

      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });

			//this.related = settings.getRelated();
      this.listLoading = true;
      this.getRecords();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// xdata.vue?2db1c9aa